<template>
  <v-container fluid fill-height pa-0 ma-0>
    <!--  <v-app-bar app elevation="0" color="transparent" clipped-right clipped-left>
      <v-spacer></v-spacer>

      <language></language>
    </v-app-bar> -->

    <!-- Sizes your content based upon application components -->
    <v-container style="height: 400px;">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="subtitle-1 text-center" cols="12">
          <img src="@/assets/logo-white.svg" alt="avatar" width="240" />
        </v-col>
        <v-col cols="2">
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="5"
          ></v-progress-linear>
        </v-col>
        <v-col class="subtitle-1 text-center" cols="12">
          {{ this.$Amplify.I18n.get("Loading...") }}
        </v-col>
        <v-col class="subtitle-1 text-center" cols="12">
          Esto puede tardar varios segundos
        </v-col>
        <v-col class="subtitle-2 text-center" cols="12">
          <strong>¿Necesita Ayuda?</strong>
        </v-col>
        <v-col class="subtitle-1 text-center" cols="12">
          soporte@pac.report
        </v-col>
      </v-row>
    </v-container>

    <!-- <v-content pa-0 ma-0>

      <v-container pa-0 ma-0>
       
        <v-layout align-center justify-center>
          <img src="@/assets/logo-white.svg" alt="avatar" width="240" />

          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            rounded
            height="6"
            color="primary"
          ></v-progress-linear>
        </v-layout>
      </v-container>
    </v-content> -->

    <v-footer app color="transparent">
      <v-layout align-center justify-center>
        <span class="text-center body-2"
          >&reg; AUTOMATIZACION Y ROBOTICA AIBOT S.A.S 2024 -
          {{ this.$Amplify.I18n.get("All rights reserved") }}</span
        >
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import { getCuenta } from "@/api/private/cuentas";
import { mapActions } from "vuex";
export default {
  name: "Preloader",
  components: {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions(["setMisCpcs", "setEmpresa", "setSuscripcion"]),
    loadEmpresa: async function() {
      try {
        let { data } = await getCuenta();
        let { usuario, empresa, cpcs, suscripcion } = data;
        if (usuario) {
          if (usuario.verificado) {
            this.loading = false;
            this.setMisCpcs(cpcs);
            this.setEmpresa(empresa);
            if (suscripcion) {
              if (!empresa.activo) {
                this.$router.push("/suscription");
              } else {
                this.setSuscripcion(suscripcion);
                this.$router.push("/dashboard/inicio");
              }
            } else {
              this.setSuscripcion(suscripcion);
              this.$router.push("/suscription");
            }
          } else {
            this.$router.push("/verificacion");
          }
        } else {
          //console.log("COMPLETAR REGISTRO");
          this.$router.push("/complete-register");
        }
      } catch (e) {
        console.log(e);
        if (e.response.status == 504) {
          this.loadEmpresa();
        } else {
          //this.setError(e);
        }
        //this.setError(e);
      }
    },
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
    this.loading = true;
    this.loadEmpresa();
    /*  setTimeout(() => {
      this.loading = false;
      this.$router.push("/");
    }, 5000); */
  },
};
</script>
